<script>
  import ActionReportMixin from './ActionReportMixin.vue'

  export default {
    name: 'RbvHotelRfpBidManagerSendRateLoadingRequestActionReport',
    mixins: [ ActionReportMixin ],
    data () {
      return {
        messages: {
          'OK': 'Success!',
          'NOT_FOUND': `Bid was not found`,
          'ERROR': 'Request not sent due to an unknown error'
        }
      }
    },
    computed: {
      title () { return this.items.length === 1 ? 'Requests sent!' : 'There were errors...' },
      message () {
        return this.items.length === 1
          ? 'We were not able to send requests because of the reason listed below:'
          : `${this.items.length - this.failures} of ${this.items.length} successfully sent.<br /> We were not able to send others because of the reasons listed below:`
      }
    }
  }
</script>
